import { defineMessages } from 'react-intl';

export const InventorizeMeterPage = defineMessages({
  apiKeyErrorMessage: {
    id: 'app.inventorizeMeter.apiKeyErrorMessage',
    defaultMessage: 'Zkontroluj správnost Api Klíče... ¯\\_(ツ)_/¯',
  },
  loadingMeter: {
    id: 'app.inventorizeMeter.loadingMeter',
    defaultMessage: 'Načítám údaje měřidla...',
  },
});

export const InventorizeStep = defineMessages({
  locationStep: {
    id: 'app.InventorizeStep.locationStep',
    defaultMessage: 'Umístění měřidla',
  },
  mapStep: {
    id: 'app.InventorizeStep.mapStep',
    defaultMessage: 'Mapa',
  },
  floorplanStep: {
    id: 'app.InventorizeStep.floorplanStep',
    defaultMessage: 'Půdorys',
  },
  detailStep: {
    id: 'app.InventorizeStep.detailStep',
    defaultMessage: 'Detail měřidla',
  },
  readingStep: {
    id: 'app.InventorizeStep.readingStep',
    defaultMessage: 'Dálkový odečet',
  },
  reviewStep: {
    id: 'app.InventorizeStep.reviewStep',
    defaultMessage: 'Kontrola',
  },
});
